/* eslint-disable no-underscore-dangle */
import { Box, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';

import { styles } from './styles';
import TableMenu from './table-menu';

const ToursTable = ({ data }) => {
  const processTripDifficulty = (difficultyLevel) => {
    switch (difficultyLevel) {
      case 'BEGINNER':
        return 'Для начинающих';
      case 'ADVANCED':
        return 'Для продвинутых';
      case 'AMATEUR':
        return 'Для любителей';
      case 'EXPERT':
        return 'Для экспертов';
      default:
        return '';
    }
  };
  return (
    <TableContainer overflowX='hidden'>
      <Table sx={styles.tableWrapper} variant='striped' colorScheme='blue'>
        <Thead sx={styles.tableHeading}>
          <Tr sx={styles.tableRow}>
            <Th>Название</Th>
            <Th>Сложность</Th>
            <Th>Можно с детьми</Th>
            <Th>Людей в группе</Th>
            <Th>Завершён</Th>
            <Th isNumeric>Цена</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.map((tour) => (
            <Tr sx={styles.tableRow} key={tour._id}>
              <Td>{tour.name}</Td>
              <Td>{processTripDifficulty(tour.difficultyLevel)}</Td>
              <Td pl='3vw'>{tour.isPossibleWithChildren ? 'Да' : 'Нет'}</Td>
              <Td pl='3vw'>{tour.totalNumberOfPlacesInGroup}</Td>
              <Td pl='2vw'>{new Date(tour.date.to).getTime() > Date.now() ? 'Нет' : 'Да'}</Td>
              <Td>
                <Box sx={styles.cellWithMenu}>
                  <Text>
                    {tour.price.value} {tour.price.currency}
                  </Text>
                  <TableMenu tourData={tour} />
                </Box>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default ToursTable;
